module.exports = __webpack_public_path__ + "static/media/ic_plus-primary.62db7fb9.svg";